<template>
  <div class="col-md-12">
    <h3>Envoyer une notification</h3>
    <div class="col-md-4">
      <custom-select :field="fields[0]" 
        :value="fields[0].value" 
        :field_idx="0"
        @field-updated="updateMethod($event)"
      >
      </custom-select>
      <button v-if="notificationId" @click="sendNotification" class="btn btn-complete m-t-10">Envoyer</button>
    </div>
    <div class="col-md-6">
      <div v-if="notificationId" class="m-t-10">Message de la notification : <span class="m-l-10">{{ notificationMessage }}</span></div>
    </div>

    <!-- <div class="col-md-6">
      <span class="top-label">Envoyer la notification par :</span>
      <ul class="notif-type-form">
        <li class="checkbox check-complete">
          <input type="checkbox" id="cbox1">
          <label for="cbox1">Email</label>
        </li>
        <li class="checkbox check-complete">
          <input type="checkbox" id="cbox2">
          <label for="cbox2">SMS</label>
        </li>
      </ul>
    </div> -->
  </div>
</template>

<style lang="scss" scoped>
  .top-label {
    padding: 7px 12px 0 0;
    font-family: 'Montserrat', sans-serif;
    font-size: 11px;
    text-transform: uppercase;
    font-weight: 600;
  }

  .notif-type-form {
    padding: 0;
    li {
      display: inline-block;
    }
  }
  .disabled {
    background-color: transparent;
    opacity: 0.2;
  }
</style>

<script type="text/babel">
import { mapState, mapActions } from 'vuex'
import CustomSelect from "components/Forms/Elements/Select"

export default {
  name: 'Notification_manuelle',
  data () {
    return {
      fields: [{ 
        values: [],
        multiple: false,
        placeholder: "Choisir un type de notification",
        disabled: false,
        idx: 1,
        required: true,
        value: null,
        label: "Type de notification",
        type: "select"
      }],
      customerId: this.$store.state.customer.id,
      notificationId: null
    }
  },
  components: { CustomSelect },
  mounted () {
    this.fetchManualNotifications().then(this.formattedNotificationChoices)
  },
  methods: {
    ...mapActions('notifications', [
      'fetchManualNotifications',
      'sendManualNotification'
    ]),
    resetFields () {
      this.fields[0].value = null
    },
    sendNotification () {
      let params = {
        notificationId: this.notificationId,
        customerId: this.customerId
      }
      this.sendManualNotification(params)
          .then(() => {
            this.resetFields()
            this.$emit('notification-sent', this.customerId)
          })
    },
    updateMethod(event) {
      this.fields[0].value = event.new_value
      this.notificationId = event.new_value ? event.new_value.value : null
    },
    formattedNotificationChoices () {
      _.forEach(this.manual_notifications, (manual_notification) => {
        if (manual_notification.active) {
          this.fields[0].values.push({
            id: manual_notification.id,
            name: manual_notification.name,
            message: manual_notification.message
          })
        }
      })
      this.notificationId = null
    }
  },
  computed: {
    ...mapState('notifications', ['manual_notifications']),
    notificationMessage () {
      let selectedNotif = _.head(_.filter(this.fields[0].values, value => {
        if (!_.isNil(this.fields[0].value))
          return value.name == this.fields[0].value.label
      }))
      if (selectedNotif)
        return selectedNotif.message
    }
  }
}
</script>



// WEBPACK FOOTER //
// client/components/Customer/AlertsContent/AlertsForm.vue